import { AmcLogo } from "@core/components/logo/amc-logo";
import { Checkbox, Textarea, V2Label } from "web-design-system";
import { uniqBy } from "lodash";
import { useCallback } from "react";
import { imageAssetUrl } from "@/utils/url";
import { useProposalFormContext } from "../../providers/proposal-provider";

export function CustomizeRemarks() {
  const form = useProposalFormContext();

  const remarkFunds = uniqBy(
    form.watch("proposal_funds"),
    (f) => f.fund_scheme
  );

  const handleRemarkChange = useCallback(
    (scheme: number, remark: string) => {
      const currentFunds = form.getValues("proposal_funds");
      const newFunds = currentFunds.map((cf) => {
        if (cf.fund_scheme !== scheme) return cf;
        return { ...cf, remarks: remark };
      });
      form.setValue("proposal_funds", newFunds);
    },
    [form]
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-lg flex gap-4 items-start justify-between border border-border bg-accent/50 p-4">
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <Checkbox
              checked={!!form.watch("include_remarks")}
              onCheckedChange={(val) => form.setValue("include_remarks", !!val)}
              id="include-remarks"
            />{" "}
            <V2Label htmlFor="include-remarks" className="font-medium">
              Include remarks in proposal
            </V2Label>
          </div>
          <span className="text-xs text-muted-foreground mt-2">
            For some schemes, we auto-generated remarks. Use these remarks to
            help your client understand why these schemes fit their goals.
          </span>
        </div>
        <img className="h-8 aspect-auto" src={imageAssetUrl("insight.webp")} />
      </div>
      <div className="flex flex-col gap-6">
        {remarkFunds.map((fund) => (
          <div
            key={fund.type + fund.fund_scheme_name}
            className="flex flex-col gap-2 rounded-lg"
          >
            <div className="flex items-center gap-2">
              <AmcLogo
                className="border border-border"
                amc_code={fund.amc_code as string}
                size="default"
              />
              <span className="text-sm font-medium flex-1 truncate">
                {fund.fund_scheme_name}
              </span>
            </div>
            <Textarea
              disabled={!form.watch("include_remarks")}
              placeholder="Add a remark for this scheme..."
              value={fund.remarks || ""}
              onChange={(e) =>
                handleRemarkChange(fund.fund_scheme, e.target.value)
              }
              className="text-sm min-h-25 resize-none"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
